import axios from 'axios';
import { newAbortSignal } from '../../utils';
import { PublicSettings } from '../../types/interfaces/app';

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/app/`;

export const getPublicSettings = async (): Promise<PublicSettings> => {

  const finalURL = BASE_URL + '/public';

  return await axios
    .get<PublicSettings>(finalURL, {
      headers: {
        'content-type': 'application/json'
      },
      timeout: parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        typeof AbortSignal.timeout !== 'undefined'
          ? AbortSignal.timeout(
              parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)
            )
          : newAbortSignal(parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)),
    })
    .then((response) => response.data);
};
